'use client'

import Image from 'next/image'

import { cn } from '@/lib/utils'

import { EASE, Eyebrow, QuietLink, useReveal } from '@/components/page-kit'
import { PAYROLL } from './data'

/* The authored quote with the customer's own wordmark — this quote is also
   from JSKB Associates (Finance Head), so jskba.jpg is the correct mark and the
   pairing states nothing untrue.

   There is no photograph on this page: all four payroll images in /public are
   612×408, which would be visibly soft in a full-bleed band. Type carries it
   instead, which suits the statement grammar the rest of the page uses. */

export function PayrollProof() {
  const block = useReveal<HTMLDivElement>(0.15)

  return (
    <section className="pt-16 sm:pt-20 md:pt-28">
      <div className="container mx-auto">
        <div ref={block.ref} className="max-w-4xl">
          <Eyebrow>Proof</Eyebrow>

          <blockquote
            className="mt-6"
            style={{
              opacity: block.shown ? 1 : 0,
              transform: block.shown ? 'none' : 'translateY(12px)',
              transition: `opacity 700ms ${EASE} 60ms, transform 700ms ${EASE} 60ms`,
            }}
          >
            <p className="font-heading text-2xl font-normal leading-[1.3] tracking-tight text-foreground sm:text-3xl lg:text-[40px] lg:leading-[1.25]">
              &ldquo;{PAYROLL.quote.text}&rdquo;
            </p>

            <footer className="mt-8 flex flex-wrap items-center gap-x-6 gap-y-4">
              <div className="relative h-8 w-32 shrink-0 sm:h-9 sm:w-40">
                <Image
                  src="/stories/jskba.webp"
                  alt="JSKB &amp; Associates"
                  fill
                  sizes="160px"
                  className={cn(
                    'object-contain object-left',
                    'opacity-90 mix-blend-multiply grayscale',
                    'dark:opacity-100 dark:mix-blend-screen dark:grayscale dark:invert'
                  )}
                />
              </div>

              <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
                <cite className="text-sm font-medium not-italic text-foreground">
                  {PAYROLL.quote.author}
                </cite>
                <span className="text-sm text-muted-foreground">
                  {PAYROLL.quote.role}
                </span>
              </div>
            </footer>
          </blockquote>

          <div
            className="mt-8"
            style={{
              opacity: block.shown ? 1 : 0,
              transition: `opacity 700ms ${EASE} 260ms`,
            }}
          >
            <QuietLink href="/customer-stories">Read the full story</QuietLink>
          </div>
        </div>
      </div>
    </section>
  )
}
